import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.backgroundColorcomponent};
  padding: 20px;
  border-radius: 10px;
  left: 0;
  top: 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  &.card {
    max-width: 49%;
    height: ${(props) => (props.isFullScreen ? '90%' : 'auto')};
    @media (max-height: 1080px) {
      height: ${(props) => (props.isFullScreen ? '88%' : 'auto')};
    }
    @media (max-height: 930px) {
      height: ${(props) => (props.isFullScreen ? '85%' : 'auto')};
    }
    @media (max-height: 750px) {
      height: ${(props) => (props.isFullScreen ? '83%' : 'auto')};
    }
    @media (max-height: 660px) {
      height: ${(props) => (props.isFullScreen ? '80%' : 'auto')};
    }
    @media (max-height: 560px) {
      height: ${(props) => (props.isFullScreen ? '77%' : 'auto')};
    }
    @media (max-width: 586px) {
      ${(props) => (props.isFullScreen
    ? 'position:fixed; z-index:6; width:100%; height:100%;'
    : '')};
    }
  }

  .card-content {
    z-index: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
    height: ${(props) => (props.isFullScreen ? '100%' : props.contentHeight)};
    max-height: ${(props) => (props.isFullScreen ? '100%' : '500px')};
    margin: ${(props) => (props.isFullScreen ? '10' : '0')};
    overflow: ${(props) => (props.isFullScreen && props.withScroll ? 'auto' : '')};
    position: relative;
    flex-direction: column;
  }

  .card-title {
    font-size: 1.6rem;
    color: ${(props) => props.theme.colors.cartTitleColor};
    padding-bottom: 8px;
    font-weight: bold;
    display: flex;
    align-items: center;

    p {
      display: inline-block;
      margin-left: 5px;
      font-size: 1.4rem;
      text-transform: uppercase;

      span {
        font-style: oblique;
        font-weight: 300;
      }
    }
  }

  .echarts-for-react {
    width: 100% !important;
    height: 100% !important;
  }

  .card-title-complement {
    cursor: default;
  }

  .card-title-complement-focusable {
    &:hover {
      background: ${(props) => props.theme.card.titleComplementHoverBackgroud};
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  &.table-mode-header {
    padding-bottom: 16px;
    margin-bottom: 22px;
    border-bottom: 1px solid ${(props) => props.theme.colors.details};
  }
`;

export const CardLine = styled.div`
  width: 90px;
  height: 1px;
  background-color: ${(props) => props.theme.colors.details};
`;

export const HeaderGroup = styled.div`
  width: 70%;
  display: flex;
  align-items: center;
  flex-direction: row;

  &.justify-end {
    justify-content: flex-end;
  }

  @media (max-width: 586px) {
    // width: calc(100% - 46px);
    width: 60%;
  }
`;

export const HeaderItem = styled.div`
  width: 50%;

  &:not(:last-child) {
    margin-right: 10px;
  }

  @media (max-width: 586px) {
    width: 53%;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  button {
    background: transparent;
    border: 0;
    color: ${(props) => props.theme.colors.actionButtonsColor};
    cursor: pointer;
    padding: 0;
    &:last-of-type {
      margin-left: 10px;
    }
  }
  .fullscreen-wrapper {
    display: block;
  }
  @media (max-width: 586px) {
    .fullscreen-wrapper {
      display: none;
    }
  }
`;

export const Tags = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  overflow-x: hidden;
  .tag {
    background-color: #f5f6fa;
    color: #610082;
    border: 0;
    font-size: 1.4rem;
    text-transform: capitalize;
    /* font-weight: 600; */
    padding: 3px 16px;
    border-radius: 5px;
    cursor: pointer;

    &:not(:last-of-type) {
      margin-right: 16px;
    }
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 40px;

  &.flex-container-has-border-bottom {
    padding-bottom: 31px;
    margin-bottom: 24px;
    border-bottom: 1px solid ${(props) => props.theme.colors.details};
  }
`;

export const CardType = styled.div`
  font-size: 1.4rem;
  color: ${(props) => props.theme.colors.cardTypeColor};
  padding-bottom: 8px;
  font-weight: normal;
  margin-right: 10px;
`;

export const LabelSurveyContent = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const LabelSurveySurveyQuestionDescription = styled.span`
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.cardTypeColor};
  font-weight: normal;
`;

export const LabelSurveyQuestionComplement = styled.span`
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.constrat};
  font-weight: normal;
`;
